<div *ngIf="options" id="highchartsGrafico" style="height: 100%; flex: 1">
	<highcharts-chart
		#highchartsGrafico
		(chartInstance)="onChartCreated($event)"
		[Highcharts]="Highcharts"
		[options]="options"
		[style]="styleChart">
	</highcharts-chart>
</div>
